/**
 * Куда вести переход на детальную страницу задачи.
 *
 * Страниц две и они живут параллельно: legacy `/tasks-new/:id` на старом бэке и
 * `/tasks-v2/:id` на новом. Выбор зависит не от места перехода, а от сессии —
 * под нативной сессией legacy-группа `/tasks` в бэке удалена, и старая страница
 * там всё равно не откроется.
 *
 * Поэтому путь собирается здесь, а не хардкодится строкой на каждом экране: их
 * больше тридцати (таблица, календарь, канбан, чаты, проекты, аналитика), и на
 * следующем шаге переезда менять их пришлось бы снова.
 *
 * Это обычная функция, а не хук: она нужна и в обработчиках, и в `<Link to>`, и
 * вне React. Реактивность тут не нужна — тип сессии в пределах жизни страницы не
 * меняется, вход и выход перемонтируют приложение целиком.
 */
import { useAuthStore } from '@/store/auth';

export const TASK_DETAIL_PATH_LEGACY = '/tasks-new';
export const TASK_DETAIL_PATH_V2 = '/tasks-v2';

export function taskDetailPath(id: string | number): string {
  const isNativeSession = Boolean(useAuthStore.getState().nativeUser);
  const base = isNativeSession ? TASK_DETAIL_PATH_V2 : TASK_DETAIL_PATH_LEGACY;

  return `${base}/${id}`;
}
